module.exports = __webpack_public_path__ + "static/media/1.Portable 4 Stroke Sprayer.d89550a9.jpg";